// @ts-nocheck

import React, { useMemo } from 'react';
import cn from 'classnames';
import { useAtomValue } from 'jotai';
import { Container, Row, Col } from 'react-bootstrap';
import { CLOUDFRONT_LANDING_PAGE_ROOT_URL, LANDING_PAGE_VIEWS } from '@shared/config/constants/app';
import { useCheckUniqueApiSource } from '@shared/hooks/useCheckUniqueApiSource';
import { dcbAtom, globalAtom } from '@shared/store/slice-atoms';
import { isVariationV3Route, isVariationV4Route, isVariationV5Route } from '@shared/utils/general';
import { hungamaCointriesList } from '@shared/ui/logo/model/utils';
import { OperatorsMessage } from '@shared/ui/operators-message/ui/OperatorsMessage';
import { LanguageSelector } from '@shared/ui/language-selector';
import Logo from '@shared/ui/logo/ui/Logo';
import { useCheckMarkLYCondition } from '@features/phone-subscription/model/hooks/useCheckMarkLYCondition';
import { isAg26MarketingVariation } from '@shared/ui/unlock-vuz-banner';
import headerVuzLogo from '@shared/assets/lg_ag26/header_vuz_logo.svg';
import redbullMobileLogo from '@shared/assets/redbull/redbull-mobile-logo.png';
import styles from '@shared/ui/header/styles/Header.module.css';

const back = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/backlp.webp`;

const Header = ({
  languageConfig = {},
  isMin = false,
  logoConfig = {},
  renderLogo = true,
  isWhite = false,
}) => {
  const { redirectURL = '' } = logoConfig;
  const { showLanguageSelector = true } = languageConfig;

  const dcb = useAtomValue(dcbAtom);
  const { landingPageView } = useAtomValue(globalAtom);

  const homeData = dcb.homeData;
  const isV3Route = isVariationV3Route(dcb.variationKey);
  const isV4Route = isVariationV4Route(dcb.variationKey);
  const isV5Route = isVariationV5Route(dcb.variationKey);

  const uniqueApiSource = useCheckUniqueApiSource();
  const { isCheckMarkLY } = useCheckMarkLYCondition();
  const isLgAg26 = isAg26MarketingVariation();
  const isLogoLeft = logoConfig?.position === 'left' && !isCheckMarkLY;
  const isRedbullSALanding = homeData?.source === 'api-web-RedbullSA';
  const isV3PhoneNumberView = landingPageView === LANDING_PAGE_VIEWS.PHONE_NUMBER;

  const goBackComponent = () => {
    if ((isV3Route || isV4Route) && !redirectURL) {
      return null;
    }

    return !uniqueApiSource && !isLogoLeft ? (
      <Col>
        {redirectURL && (
          <img
            src={back}
            className="backlp"
            alt="backlp"
            onClick={() => {
              window.location.pathname = '/voucher';
            }}
            style={{ cursor: 'pointer' }}
          />
        )}
      </Col>
    ) : null;
  };

  const colAdditionalStyle = useMemo(() => {
    if (isV3Route && hungamaCointriesList[homeData?.country?.toUpperCase()]) {
      return { paddingRight: '6px', paddingLeft: '6px' };
    }

    return {};
  }, [isV3Route, homeData?.country]);

  return (
    <>
      <section
        style={isV5Route || isLgAg26 ? { paddingTop: '16px' } : {}}
        className={cn(!isV4Route && 'landing-section-1', isMin && 'dark-bg')}
      >
        <Container
          className={cn('container-sm', !uniqueApiSource && !isV5Route && !isLgAg26 && 'py-4')}
        >
          {isRedbullSALanding ? (
            <div className={styles.redbullMobileLogo}>
              <img src={redbullMobileLogo} alt="Red Bull Mobile" />
            </div>
          ) : null}
          {isLgAg26 ? (
            <div className={styles.lgAg26Bar}>
              <div className={styles.lgAg26Logo}>
                <img src={headerVuzLogo} alt="VUZ" width={62} height={27} />
              </div>
              {showLanguageSelector ? (
                <LanguageSelector
                  uniqueApiSource={uniqueApiSource}
                  languageConfig={languageConfig}
                  isMin={isMin}
                />
              ) : null}
            </div>
          ) : isCheckMarkLY ? (
            <Row className={styles.centeredLogoRow}>
              <Col xs={12} className={styles.centeredLogoCol}>
                <Logo
                  renderLogo={renderLogo}
                  logoConfig={logoConfig}
                  isMin={isMin}
                  uniqueApiSource={uniqueApiSource}
                />
              </Col>
              {showLanguageSelector ? (
                <div className={styles.languageSelectorOverlay}>
                  <LanguageSelector
                    uniqueApiSource={uniqueApiSource}
                    languageConfig={languageConfig}
                    isMin={isMin}
                  />
                </div>
              ) : null}
            </Row>
          ) : (
            <Row style={uniqueApiSource ? { height: '44px' } : null}>
              {goBackComponent()}
              <Col style={uniqueApiSource ? { height: '44px' } : colAdditionalStyle}>
                <Logo
                  renderLogo={renderLogo}
                  logoConfig={logoConfig}
                  isMin={isMin}
                  uniqueApiSource={uniqueApiSource}
                />
              </Col>
              <Col style={uniqueApiSource ? { height: '44px' } : colAdditionalStyle}>
                {showLanguageSelector ? (
                  <LanguageSelector
                    uniqueApiSource={uniqueApiSource}
                    languageConfig={languageConfig}
                    isMin={isMin}
                  />
                ) : null}
              </Col>
            </Row>
          )}
        </Container>
      </section>

      {window.location.pathname.split('/')[1] === 'thankyou' ||
      isV3PhoneNumberView ||
      isLgAg26 ? null : (
        <OperatorsMessage isWhite={isWhite} />
      )}
    </>
  );
};

export { Header };
